import apiFetch from '../apiFetch'

export default function (documentId, token) {
  return apiFetch({ endPoint: `documentHistorical/${documentId}/visor`, method: 'GET', body: null, token: token })
}
